import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturesGrid from './components/FeaturesGrid';
import StatsSection from './components/StatsSection';
import CategoriesGrid from './components/CategoriesGrid';
import TestimonialSection from './components/TestimonialSection';
import ArticleCTA from './components/ArticleCTA';
import MainSiteCTA from './components/MainSiteCTA';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const siteUrl = 'https://superbuyspreadsheet.best';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Superbuy Spreadsheet',
      url: siteUrl,
      description: 'The most trusted Superbuy Spreadsheet featuring verified products, quality control guides, shipping tutorials, and curated buying resources.',
      inLanguage: 'en',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'Superbuy Spreadsheet',
      url: siteUrl,
      description: 'The most trusted Superbuy Spreadsheet — 5,200+ verified products, expert QC guides, shipping tutorials, and curated buying resources for smarter shopping.',
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <main>
        <Navbar />
        <Hero />
        <FeaturesGrid />
        <StatsSection />
        <CategoriesGrid />
        <TestimonialSection />
        <ArticleCTA />
        <MainSiteCTA />
        <FAQSection />
        <Footer />
      </main>
    </>
  );
}